import { useContext } from 'react'

import { AuthContext, AuthContextType, AuthenticatedUser } from '../contexts/auth'

export default function useAuth<Unverified extends boolean = false>() {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth must be used within an AuthProvider')

  return context as Unverified extends true ? AuthContextType : AuthenticatedUser
}
